import { createAction, props } from '@ngrx/store';
import { IValidateMobileRequest, IValidateMobileResponse, IValidateMobileSuccess } from '../../../core/models/validate-mobile.model';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';

// * -------------------  // * CHECK VALID MOBILE NUMBER------------------- * /
export const checkValidMobileNumberRequest = createAction(
  '[ValidMobileNumber] check valid mobile number request',
  props<{ request: IValidateMobileRequest }>()
);

export const checkValidMobileNumberSuccess = createAction(
  '[ValidMobileNumber] check valid mobile number response',
  props<{ response: IValidateMobileSuccess }>()
);

export const checkValidMobileNumberFailure = createAction(
  '[ValidMobileNumber] check valid mobile number failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);


export const validateMobileNumberRequest = createAction(
  '[ValidMobileNumber] valid mobile number request',
  props<{ request: IValidateMobileRequest }>()
);

export const validateMobileNumberSuccess = createAction(
  '[ValidMobileNumber] valid mobile number response',
  props<{ response: IValidateMobileResponse }>()
);

export const validateMobileNumberFailure = createAction(
  '[ValidMobileNumber] valid mobile number failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);